module.exports = __webpack_public_path__ + "static/bluegradient-7079afbf3c4e3c18476035b17fba01e4.jpeg";